// cleanup_convert_to_typescript_file_ALERTS

import React from 'react';
import PropTypes from 'prop-types';

import Alert from '@glu/alerts-react';

import { ALERTVARIATIONS } from 'constants.js';

import useStyles from './BasicResponseMessage.styles';

const BasicResponseMessageComponent = ({ onClearResults, result }) => {
  const { outer, table } = useStyles();
  return (
    <Alert
      dataQa="basic-message-alert"
      variant={result.variant}
      details={result.variant === ALERTVARIATIONS.SUCCESS && result?.displayData?.length}
      onHide={onClearResults(result.name)}
      message={result.title}
    >
      <div className={outer}>
        <table className={table}>
          <thead>
            <tr>
              {result.displayData.map(([name]) => (
                <td key={name}>{name}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {result.data.map((item, index) => (
              <tr key={item.id || index}>
                {result.displayData.map(([name, transform]) => (
                  <td key={name}>{transform(item)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Alert>
  );
};

BasicResponseMessageComponent.propTypes = {
  onClearResults: PropTypes.func,
  result: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    displayData: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.func]))
    ),
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    variant: PropTypes.string
  })
};

BasicResponseMessageComponent.defaultProps = {
  onClearResults() {},
  result: {
    data: [],
    displayData: [],
    name: 'successItems',
    title: '',
    variant: 'info'
  }
};

export default BasicResponseMessageComponent;
